import React, { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import HelperCardBody from "./HelperCardBody";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { HelperCardTitle } from "../../../../Constants/Constants";
import { HelperCardData, HelperCardSubTitle } from "../../../../Data/UiKits/Dropdown";

const HelperCard = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={HelperCardTitle} span={HelperCardSubTitle} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            {HelperCardData &&
              HelperCardData.map((item, index) => (
                <Fragment key={index}>
                  <HelperCardBody item={item} />
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default HelperCard;
